import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TopicFilterChipProps {
  topic: string;
  onClear: () => void;
}

export const TopicFilterChip = ({ topic, onClear }: TopicFilterChipProps) => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'unified_ai_insights' });
  return (
    <div
      className="flex items-center gap-2 text-sm text-muted-foreground"
      data-testid="topic-filter-chip"
    >
      <span>{t('topic_filter_prefix')}</span>
      <button
        type="button"
        onClick={onClear}
        className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-3 py-1 text-foreground hover:bg-accent transition-colors cursor-pointer"
        data-testid="topic-filter-chip-clear"
        aria-label={t('topic_filter_clear_aria', { topic })}
      >
        <span className="font-medium">{topic}</span>
        <X className="size-3.5" />
      </button>
    </div>
  );
};
